import $ from 'jquery'
import mapController from './mapController'

import {
    calculateDirections,
    updateLocation,
    showDirections,
    YCLatLng,
    distance,
    selectClosestStop,
} from './coordinates_v3'

class MapAdapter {
    constructor() {
        ;(this.automaticAudioEnabled = true),
            (this.conroller = null),
            (this.MarkerColors = {
                current: {
                    default: '', //#45a4fc defined in CSS
                    selected: '#ef8f22',
                },
                60301: {
                    default: '#9CCB3B', //#45a4fc defined in CSS
                    selected: '#006747',
                },
            })
    }
    setZoomLevel = zoom => {
        this.controller.map.setZoom(zoom)
    }

    setController = controller => {
        this.controller = controller
    }

    setGPSCoordinates(lat, lng, recenter, accuracy) {
        this.setGPSLocation(new YCLatLng(lat, lng), recenter, accuracy)
    }

    setGPSLocation(point, recenter, accuracy) {
        if (
            this.controller.lastRealLocation == null ||
            distance(point, this.controller.lastRealLocation) > 3 ||
            recenter
        ) {
            updateLocation(point, recenter, accuracy)
            this.controller.lastRealLocation = point
        }
        if (accuracy < 100) {
            selectClosestStop(point)
        }
    }

    stopGPSTracking() {
        if (this.controller.locationMarker) {
            this.controller.locationMarker.setMap(null)
        }
    }

    setDirections(points) {
        showDirections(points, this.hasGoogleMap)
    }

    clearTrail = () => {
        if (this.controller.currentTrail) {
            this.controller.currentTrail.polyline.setMap(null)
            this.controller.currentTrail.startMarker.setMap(null)
            this.controller.currentTrail.endMarker.setMap(null)
        }
    }

    showTrail = trail => {
        this.clearTrail()
        this.controller.currentTrail = trail
        if (trail.polyline) {
            trail.polyline.setMap(MapAdapter.map)
            trail.startMarker.setMap(MapAdapter.map)
            trail.endMarker.setMap(MapAdapter.map)
            return
        }

        var polyline = new google.maps.Polyline({
            path: trail.points,
            strokeColor: '#FF0000',
            strokeOpacity: 0.7,
            strokeWeight: 7,
        })

        trail.polyline = polyline
        polyline.setMap(this.controller.map)

        var startMarker = new google.maps.Marker({ position: trail.points[0], icon: this.controller.startTrailIcon })
        startMarker.setMap(this.controller.map)

        var endMarker = new google.maps.Marker({
            position: trail.points[trail.points.length - 1],
            icon: this.controller.endTrailIcon,
        })
        endMarker.setMap(this.controller.map)

        trail.startMarker = startMarker
        trail.endMarker = endMarker
        this.controller.map.panTo(trail.points[0])
    }

    setTrail(trailid) {
        $('.tourmenu li').removeClass('selected')
        if (trailid == '') {
            this.clearTrail()
        } else {
            $('.tourmenu [trailid=' + trailid + ']').addClass('selected')
            var i,
                trails = this.conroller.trails
            for (i = 0; i < trails.length; i++) {
                if (trails[i].id == trailid) {
                    this.showTrail(trails[i])
                    return
                }
            }
        }
    }

    enableAutomaticAudio(enable) {
        this.automaticAudioEnabled = enable
    }

    setColorInstitutionOverride(inst_id) {
        if (this.MarkerColors[inst_id]) this.MarkerColors.current = this.MarkerColors[inst_id]
    }

    selectStop = (stopid, startAudio, sendStopNotification = true) => {
        if (!this.controller || !this.controller.map) return
        if (
            this.controller.map.activeTooltip &&
            this.controller.currentStop &&
            stopid == this.controller.currentStop.id
        )
            return

        var stop = this.controller.getStopById(stopid)
        if (!stop) {
            return
        }

        this.controller.player.stop()

        this.controller.currentStop = stop
        for (var ii = 0; ii < this.controller._stops.length; ++ii) {
            if (this.controller._stops[ii].id != stopid) {
                this.controller.updateHover(this.controller._stops[ii].id, false, false)
                this.controller._stops[ii].markerLabel && this.controller._stops[ii].markerLabel.setSelected(false)
                $('#stop_' + this.controller._stops[ii].id).css({ color: this.MarkerColors.current.default })
            }
        }
        this.controller.updateHover(stopid, true, false)

        this.controller.selectedStop = stop
        $('#stop_' + stop.id).css({ color: this.MarkerColors.current.selected })
        stop.markerLabel && stop.markerLabel.setSelected(true)

        this.controller.showStopInfoPopup(stop, true)

        if (sendStopNotification) {
            this.controller.delegate.stopSelected(stop)
        }

        try {
            if (!$('.stopmenu [stopid=' + stopid + ']').hasClass('selected')) {
                $('.stopmenu li').removeClass('selected')
                $('.stopmenu [stopid=' + stopid + ']').addClass('selected')
                $('.stopmenu').animate({ scrollTop: $('.stopmenu .selected').position().top }, 400)
            }
        } catch (e) {}
    }

    /**
     * Hides and nullifies the current map tooltip.
     */
    hideTooltip = () => {
        if (this.controller.map.activeTooltip) {
            this.controller.map.activeTooltip.setMap(null)
            this.controller.map.activeTooltip = null
        }
    }

    mapClicked = map => {
        if (!this.preventClickPropogation) {
            if (map.activeTooltip != null) {
                map.activeTooltip.setMap(null)
                map.activeTooltip = null
                mapController.selectedStop = null
            }
        } else {
            this.preventClickPropogation = false
        }
    }

    /**
     * Uses google's directions service to calculate a path from start to end.
     * @param {google.maps.LatLng} start          Google maps LatLng origin.
     * @param {google.maps.LatLng} end            Google maps LatLng destination.
     * @param {Function}           callback       Returns the path as an array of google.maps.LatLng's.
     * @param {Function}           errorCallback  Returns an error message.
     */
    calculateDirections(start, end, callback, errorCallback) {
        calculateDirections(start, end, callback, errorCallback)
    }

    audioStarted(stopid) {
        this.controller.stopIdPlaying = stopid
        if (this.controller.selectedStop != null && this.controller.selectedStop.id == stopid) {
            document.getElementById('bbleaudio_' + stopid).src = this.controller.delegate.getPath(
                'images/audiospeaker.png'
            )
            document.getElementById('bbleaudio_' + stopid + '_on').src = this.controller.delegate.getPath(
                'images/audiospeaker-on.png'
            )
        }
    }

    audioStopped(stopid) {
        this.controller.stopIdPlaying = null
        if (this.controller.selectedStop != null && this.controller.selectedStop.id == stopid) {
            document.getElementById('bbleaudio_' + stopid).src = this.controller.delegate.getPath(
                'images/audiospeaker-stop.png'
            )
            document.getElementById('bbleaudio_' + stopid + '_on').src = this.controller.delegate.getPath(
                'images/audiospeaker-stop-on.png'
            )
        }
    }
}

export default new MapAdapter()
